import '../../components/app/DemandedJobs.scss';
import '../../components/app/HireTalent.scss';
import './CustomSearchBar.scss';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Search } from '@mui/icons-material';
import history from '../../history';


function CustomSearchBar({placeholder}) {
    const [searchParams] = useSearchParams();
    const [searchInput, setSearchInput] = useState('');
    const location = useLocation();
    
    useEffect(() => {
        setSearchInput(searchParams.get("searchInput") ? searchParams.get("searchInput") : '');
    }, [searchParams]);

    const handleSubmit = (e) => {
        e.preventDefault();
        history.push(location?.pathname?.replaceAll('/search', '').replaceAll(/\/$/g,'')+"/search?" + (searchParams.get("type") ? 'type=' + searchParams.get("type") + '&' : '') + (searchInput ? 'searchInput=' + searchInput : ''))
        history.go();
    };


    return (
        <div className='search-wrp'>
            <form className='search-bar-wrp' onSubmit={handleSubmit}>
                <input type="text" value={searchInput} placeholder={placeholder} name='searchInput' onChange={(e) => setSearchInput(e.target.value)}></input>
                <div className='search-icon-wrp' onClick={handleSubmit}><Search /></div>
            </form>
        </div>
    );
}

export default CustomSearchBar;